/* istanbul ignore file */
export default function downloadFile({ fileName, file }) {
    const element = document.createElement('a');
    const url = window.URL.createObjectURL(file);
    element.setAttribute('href', url);
    element.setAttribute('download', fileName);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent('click', {
        bubbles: false,
        cancelable: true,
        view: window
    }));
    document.body.removeChild(element);
    window.setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 0);
}
//# sourceMappingURL=downloadFile.js.map